/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectorRef, Component, Input, OnChanges, SimpleChanges} from '@angular/core';

import {safeDetectChanges} from '../common/util/safe-detect-changes';
import template from './line-item-template-analysis-page.component.html';

@Component({
  standalone: false,
  selector: 'adn-line-item-template-analysis-page',
  template
})
export class LineItemTemplateAnalysisPageComponent implements OnChanges {
  @Input() model: any;
  @Input() modelComms: any;
  @Input() isNew: boolean;

  effectiveIsNew = false;
  lineItemTemplate: any;
  apiModel: any;

  private subscribedModelComms: any;

  constructor(private readonly cdr: ChangeDetectorRef) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.isNew) {
      this.effectiveIsNew = !!this.isNew;
    }
    if (changes.model) {
      this.lineItemTemplate = this.model;
      this.apiModel = this.model;
    }
    if (changes.modelComms) {
      this.subscribeModelComms();
    }
  }

  private subscribeModelComms(): void {
    if (!this.modelComms || this.subscribedModelComms === this.modelComms) {
      return;
    }
    this.subscribedModelComms = this.modelComms;
    // Route isNew never flips after save; modelComms does.
    this.modelComms.addSubscriber((data: any, type: any, isNewFromComms?: boolean) => {
      if (type) {
        return;
      }
      if (isNewFromComms === true || isNewFromComms === false) {
        this.effectiveIsNew = isNewFromComms;
      } else if (data?.name) {
        this.effectiveIsNew = false;
      }
      if (data) {
        this.lineItemTemplate = data;
        this.apiModel = data;
      }
      safeDetectChanges(this.cdr);
    });
  }
}
